<div class="card">
  <div class="card-header card-no-border">
    <h5>{{ 'HR Metrics Overview' | translate }}</h5>
  </div>
  <div class="card-body pt-0">
    <span class="help-icon fas fa-info-circle"
        [ngbTooltip]="'Indicates the growth of Employee satisfaction, turnover and cost for training' | translate"
        placement="top"
        container="body"></span>
    <div class="row m-0 overall-card">
      <div class="col-xl-8 col-md-12 col-sm-7 p-0">
        <div class="chart-right">
          <div class="row">
            <div class="col-xl-12">
              <div class="card-body p-0">
                <div class="current-sale-container">
                  <div id="chart-hr-metrics">
                    <apx-chart
                      [series]="chartOptions.series"
                      [chart]="chartOptions.chart"
                      [plotOptions]="chartOptions.plotOptions"
                      [grid]="chartOptions.grid"
                      [dataLabels]="chartOptions.dataLabels"
                      [stroke]="chartOptions.stroke"
                      [fill]="chartOptions.fill"
                      [legend]="chartOptions.legend"
                      [colors]="chartOptions.colors"
                      [xaxis]="chartOptions.xaxis"
                      [yaxis]="chartOptions.yaxis"
                      [labels]="chartOptions.labels"
                      [states]="chartOptions.states"
                      [responsive]="chartOptions.responsive"
                    ></apx-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-12 col-sm-5 p-0">
        <div class="row g-sm-4 g-2">
          <ng-container *ngFor="let item of balance">
            <ng-container *ngIf="item.url; else noLink">
              <a [routerLink]="[item.url]">
                <div class="col-xl-12 col-md-4">
                  <div class="light-card balance-card widget-hover">
                    <div class="svg-box">
                      <fa-icon [icon]="item.icon"></fa-icon>
                    </div>
                    <div>
                      <span class="f-light">{{ item.title | translate }}</span>
                      <h6 class="mt-1 mb-0">{{ item.value }}</h6>
                    </div>
                  </div>
                </div>
              </a>
            </ng-container>
          
            <!-- Fallback: Render without <a> if item.url is missing -->
            <ng-template #noLink>
              <div class="col-xl-12 col-md-4">
                <div class="light-card balance-card widget-hover">
                  <div class="svg-box">
                    <fa-icon [icon]="item.icon"></fa-icon>
                  </div>
                  <div>
                    <span class="f-light">{{ item.title | translate }}</span>
                    <h6 class="mt-1 mb-0">{{ item.value }}</h6>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>          
        </div>
      </div>
    </div>
  </div>
</div>
